
import { computed, defineComponent } from "vue";
import { useStore } from 'vuex';

export default defineComponent({
  name: 'gamesListGameBoxComponent',
  props: ["item", "mainnetGameTitles", "network"],
  setup(props){
    const store = useStore();
    const assetUrl = computed(() => {
      return store.getters['config/assetUrl'];
    });

    const testnetLabel = computed(() => {
      return store.getters['config/configTestnetLabel'];
    });

    const mainnetLabel = computed(() => {
      return store.getters['config/configMainnetLabel'];
    });

    const testnetWebWallet = computed(() => {
      return store.getters['config/getTestnetWebWallet'];
    });

    const mainnetWebWallet = computed(() => {
      return store.getters['config/getMainnetWebWallet'];
    });

    const isMainnet = computed(() => {
      return props.mainnetGameTitles.includes(props.item.title);
    });

    return {
      assetUrl,
      testnetLabel,
      mainnetLabel,
      isMainnet,
      testnetWebWallet,
      mainnetWebWallet,
    }
   }
});
